import { mapToId, sortByCreatedAt } from '@witmetrics/utils/arrays';
import { useProjectOrders } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import { Tab } from '@/components/TabsBlock';
import Section from '@/overlays/CaseOverlay/Section';
import SectionTitle from '@/overlays/CaseOverlay/SectionTitle';
import OrdersList from '@/components/OrdersList';
import PracticeOrderDialog from '@/dialogs/PracticeOrderDialog';
import EmptyMessage from '@/overlays/CaseOverlay/EmptyMessage';
import { classes } from './utils';

export type OrdersTabProps = {
  isFetchingData?: boolean;
  name: string;
  label: string;
};

export default function OrdersTab({
  isFetchingData,
  name,
  label,
}: OrdersTabProps) {
  const { activeProjectId } = useAppState();
  const orders = useProjectOrders(activeProjectId!);
  const [isOrderDialogShown, toggleOrderDialog] = useToggle();

  return (
    <Tab name={name} label={label}>
      {isOrderDialogShown && (
        <PracticeOrderDialog
          projectId={activeProjectId!}
          onClose={() => toggleOrderDialog(false)}
        />
      )}
      <Section>
        <div className={classes.card}>
          <div className={classes.cardHeader}>
            <SectionTitle
              title="Orders"
              newLabel="Add order"
              onAddNew={() => toggleOrderDialog(true)}
            />
          </div>
          {orders.length > 0 ? (
            <OrdersList
              isFetchingData={isFetchingData}
              className={classes.ordersList}
              orderIds={mapToId(sortByCreatedAt(orders))}
              variant="flat"
            />
          ) : (
            <EmptyMessage>No orders.</EmptyMessage>
          )}
        </div>
      </Section>
    </Tab>
  );
}
